import { z } from 'zod';
import { EMAIL_INVALID_MESSAGE } from '../validation-messages';

/* ── Nested types ───────────────────────────── */

export const ScreenshotSchema = z.object({
    key: z.string().min(1),
    sizeBytes: z.number().int().nonnegative(),
});

/* ── Main schema ───────────────────────────── */

export const FeedbackSchema = z.object({
    title: z
        .string()
        .trim()
        .min(1, 'Title is required')
        .max(255, 'Max 255 characters'),

    description: z
        .string()
        .trim()
        .min(1, 'Description is required'),

    email: z
        .string({
            required_error: 'Email is required',
            invalid_type_error: EMAIL_INVALID_MESSAGE,
        })
        .trim()
        .min(1, 'Email is required') // ✅ FIRST
        .max(255)
        .email(EMAIL_INVALID_MESSAGE) // ✅ AFTER min
        .transform((val) => val.toLowerCase()),

    screenshots: z
        .array(ScreenshotSchema).nullable()
        .default([]),

    recordingKey: z
        .string()
        .max(512)
        .nullable()
        .optional(),

    recordingSizeBytes: z
        .number()
        .int()
        .nonnegative()
        .nullable()
        .optional(),

    pageUrl: z
        .string()
        .min(1)
        .url('Invalid URL'),

    userAgent: z
        .string()
        .min(1),
});

export type FeedbackType = z.infer<typeof FeedbackSchema>;
